import 'Src/less/automotive/batteries-landing-page.less';
import VehicleLookupForm from './components/VehicleLookupForm.vue';
import Vue from 'vue';
import { BlogCategories, BlogTagGroups } from 'Src/js/services/BlogService';
import { CustomerVehicleService } from 'JS/services/automotive/CustomerVehicleService';
import { initializeAsyncBlogCarousel } from 'Src/js/utilities/blog';
import { initializeChangeStoreButton } from '../shared/utils/store';
import { lazyLoadImages } from 'JS/global/images'; 

initializeAsyncBlogCarousel('#blpBlogCarousel', {
	heading: 'Battery Care Tips & Advice',
	viewAllLink: 'https://www.farmandfleet.com/blog/tag/batteries/',
	query: {
		categories: [BlogCategories.Automotive],
		perPage: 12,
		tags: BlogTagGroups.Batteries, 
	},

});

initializeChangeStoreButton('.alp-store__change', 'auto');

const vehicleForm = document.querySelector('.blp-search-form');
if (vehicleForm) {
	new Vue({
		el: vehicleForm,
		render: h => h(VehicleLookupForm),
		provide: {
			CustomerVehicleService: new CustomerVehicleService(),
		}
	});
}

lazyLoadImages(document.querySelector('#blp') as HTMLElement);